<!--<pre>bodyCreditCeilingGranted: {{bodyCreditCeilingGranted.value|json}}</pre>-->
<app-card-tab-section [data]="bodyCreditCeilingGranted" />

<!--<pre>bodySaleTarget: {{bodySaleTarget.value|json}}</pre>-->
<app-card-tab-section [data]="bodySaleTarget" />

<!--<pre>section penagihan kredit</pre>-->
<app-card-tab-section [data]="bodyCreditBilling" />
